import { render, staticRenderFns } from "./BiBoard.vue?vue&type=template&id=8a061dcc&scoped=true"
import script from "./BiBoard.vue?vue&type=script&lang=js"
export * from "./BiBoard.vue?vue&type=script&lang=js"
import style0 from "./BiBoard.vue?vue&type=style&index=0&id=8a061dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a061dcc",
  null
  
)

export default component.exports